import React from "react";
import { getClassName } from "@sscs/utils";
import styles from "./requiredFields.module.scss";
const RequiredFieldsLabel = ({ className }) => {
    return (React.createElement("p", { className: getClassName(styles.root, className) },
        React.createElement("span", { className: styles.asterisk, "aria-hidden": "true" }, "*"),
        "Required fields"));
};
export default RequiredFieldsLabel;
//# sourceMappingURL=RequiredFieldsLabel.js.map